module.exports = __webpack_public_path__ + "static/media/blue_dart.429f30c3.svg";